import { render } from "./FooterPlayer.vue?vue&type=template&id=01894831"
import script from "./FooterPlayer.vue?vue&type=script&lang=js"
export * from "./FooterPlayer.vue?vue&type=script&lang=js"

import "./FooterPlayer.vue?vue&type=style&index=0&id=01894831&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__